// @flow
import {SEGMENTATION_TOGGLE_DROPDOWN_VISIBILITY} from '../actions/segmentation';
import type {Action} from '../actions/segmentation';

type SegmentationReducerState = {
    +hasEnoughSpaceInFilterBar: boolean
};
export type State = {
    +segmentation: SegmentationReducerState
};

const initialState = {
    hasEnoughSpaceInFilterBar: true
};

export default function reducer(
    state: SegmentationReducerState = initialState,
    action: Action
) {
    switch (action.type) {
        case SEGMENTATION_TOGGLE_DROPDOWN_VISIBILITY:
            return {...state, hasEnoughSpaceInFilterBar: action.payload};
        default:
            return state;
    }
}
